import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FooterService {
  #showFooter = true;

  set showFooter(showFooter: boolean) {
    this.#showFooter = showFooter;
  }
  get showFooter() {
    return this.#showFooter;
  }
}
